module.exports = __webpack_public_path__ + "static/media/logo-moviedb.02a9430b.svg";